import * as React from "react";
import styled from "@emotion/styled";
import Text from "@teachers/design-system/components/Text";
import Spinner from "@teachers/design-system/components/Spinner";

export const Loading: React.FC = () => {
  return (
    <LoadingWrapper>
      <Spinner animation="border" />
      <Text>Loading...</Text>
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "1rem",
});
